module.exports = __webpack_public_path__ + "static/media/3.83f15648.jpg";